var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseBody",
    [
      _c(
        "BaseTopBar",
        [
          _c("BaseTopBarContent", { attrs: { className: "left" } }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("sidebar.journalentry")) +
                " > " +
                _vm._s(this.$route.query.jv_code) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c("BaseTopBarContent", { staticClass: "col-md-8 right" }, [
            _vm.journalEntry
              ? _c("div", { staticClass: "action" }, [
                  _vm.showOptionButton
                    ? _c("div", { staticClass: "dropdown item" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn no-bg dropdown-toggle text-secondary shake",
                            attrs: {
                              id: "dropdownMenuButton",
                              type: "button",
                              "data-toggle": "dropdown",
                              "aria-haspopup": "true",
                              "aria-expanded": "false"
                            }
                          },
                          [
                            _c("i", { staticClass: "fas fa-cog" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "name" }, [
                              _vm._v(_vm._s(_vm.$t("button.options")))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "dropdown-menu dropdown-menu-right",
                            attrs: { "aria-labelledby": "dropdownMenuButton" }
                          },
                          [
                            this.hasRoleDelete
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "dropdown-item",
                                    on: {
                                      click: function($event) {
                                        return _vm.onOpenModal()
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-trash text-danger"
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "text-danger" }, [
                                      _vm._v(_vm._s(_vm.$t("button.delete")))
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasRoleCreate
                    ? _c("div", { staticClass: "dropdown nodro item" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn no-bg text-secondary",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.openCloneModal()
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "fas fa-copy" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "name" }, [
                              _vm._v(_vm._s(_vm.$t("button.clone")))
                            ])
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.journalEntry.status == "pending" && _vm.hasRoleApprove
                    ? _c(
                        "div",
                        { staticClass: "dropdown item" },
                        [
                          [
                            _vm.journalEntry.status == "pending"
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn no-bg dropdown-toggle text-warning",
                                    attrs: {
                                      type: "button",
                                      "data-toggle": "dropdown",
                                      "aria-haspopup": "true",
                                      "aria-expanded": "false"
                                    }
                                  },
                                  [
                                    _c("i", { staticClass: "far fa-circle" }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "name" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("status.jv.pending"))
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.journalEntry.status == "approved"
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn no-bg dropdown-toggle text-success",
                                    attrs: {
                                      type: "button",
                                      "data-toggle": "dropdown",
                                      "aria-haspopup": "true",
                                      "aria-expanded": "false"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "far fa-check-circle"
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "name" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("status.jv.approved"))
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.journalEntry.status == "rejected"
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn no-bg dropdown-toggle text-danger",
                                    attrs: {
                                      type: "button",
                                      "data-toggle": "dropdown",
                                      "aria-haspopup": "true",
                                      "aria-expanded": "false"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "far fa-times-circle"
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "name" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("status.jv.rejected"))
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ],
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "dropdown-menu dropdown-menu-right"
                            },
                            [
                              _vm.journalEntry.status == "pending"
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: function($event) {
                                          return _vm.updateStatus("approved")
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "far fa-check-circle text-success",
                                        staticStyle: {
                                          position: "relative",
                                          left: "-7px"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "text-success" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("status.jv.approve"))
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.journalEntry.status == "pending"
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: function($event) {
                                          return _vm.updateStatus("rejected")
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "far fa-times-circle text-danger",
                                        staticStyle: {
                                          position: "relative",
                                          left: "-7px"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "text-danger" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("status.jv.reject"))
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        2
                      )
                    : _c(
                        "div",
                        { staticClass: "dropdown nodro item" },
                        [
                          [
                            _vm.journalEntry.status == "pending"
                              ? _c("span", { staticClass: "text-warning" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("status.jv.pending")) +
                                      "\n            "
                                  )
                                ])
                              : _vm.journalEntry.status == "approved"
                              ? _c("span", { staticClass: "text-success" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("status.jv.approved")) +
                                      "\n            "
                                  )
                                ])
                              : _vm.journalEntry.status == "rejected"
                              ? _c("span", { staticClass: "text-danger" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("status.jv.rejected")) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ]
                        ],
                        2
                      )
                ])
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "BaseContent",
        { attrs: { loading: _vm.loading } },
        [
          _c("WrapperDoc", {
            scopedSlots: _vm._u([
              {
                key: "form",
                fn: function() {
                  return [
                    _vm.journalEntry
                      ? _c("JournalEntryForm", {
                          attrs: {
                            journalEntry: _vm.journalEntry,
                            jvCode: _vm.journalEntry.jv_code,
                            isSubmitted: _vm.isSubmitted,
                            disabled: _vm.disabled || _vm.disabledForm,
                            form: _vm.form,
                            showActionButtons: !_vm.disabledForm
                          },
                          on: {
                            "update:form": function($event) {
                              _vm.form = $event
                            },
                            onSubmit: _vm.handleSubmit
                          }
                        })
                      : _vm._e()
                  ]
                },
                proxy: true
              },
              {
                key: "ref",
                fn: function() {
                  return [
                    _vm.journalEntry
                      ? _c("DocRef", {
                          attrs: {
                            refDoc: "jv",
                            refId: _vm.journalEntry._id,
                            refCode: _vm.journalEntry.jv_code,
                            showLog: _vm.getAccountSetting.log_topic.is_active,
                            showAttachFile:
                              _vm.getAccountSetting.attach_file.is_active,
                            logTopics: _vm.getAccountSetting.log_topic.options,
                            isSubmitted: _vm.isSubmitted
                          }
                        })
                      : _vm._e()
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _c("baseConfirmDeleteModal", {
            attrs: { show: _vm.modal.show, loading: _vm.modal.loading },
            on: {
              onClose: _vm.handleCloseModal,
              onCancel: _vm.handleCancleModal,
              onSubmit: _vm.handleSumitModal
            }
          }),
          _vm._v(" "),
          _c("BaseConfirmDiscardModal", {
            attrs: { show: _vm.confirmDiscardModal.show },
            on: {
              onCancel: _vm.handleDiscardCancleModal,
              onConfirm: _vm.handleDiscardConfirmModal
            }
          }),
          _vm._v(" "),
          _c("BaseConfirmCloneModal", {
            attrs: {
              show: _vm.modalConfirmClone.show,
              loading: _vm.modalConfirmClone.loading
            },
            on: {
              onClose: _vm.handleCloseCloneModal,
              onCancel: _vm.handleCancleCloneModal,
              onConfirm: function($event) {
                return _vm.handleConfirmCloneModal({
                  payload: {
                    data: _vm.payloadClone
                  },
                  createApiFn: _vm.insertJournalEntries,
                  redirectTo: "AccountsJournalEntryAll",
                  refCode: "jv_code"
                })
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a72c512", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a72c512","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/accounts/journalentry/Edit.vue
// module id = null
// module chunks = 